import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';

const API_NAME  = 'public';

//Refreshes the authorization header for making API calls
async function getDefaultAPIHeaders(body = null) {
    // In V6, fetchAuthSession returns a session object.
    // The tokens are accessed via the .tokens property.
    const session = await fetchAuthSession();

    // The raw JWT token is retrieved by calling .toString() on the idToken object.
    const idToken = session.tokens?.idToken?.toString();

    // The rest of the structure remains the same.
    return {
        headers: {
            'Content-Type': 'application/json',
            Authorization: idToken
        },
        body: body
    };
}

//Returns an object that describes the results of the API calls.
//@param error - boolean to indicate if the call was successful
//@param returnValue - the results of the API call
class APIResult {
    constructor(error, returnValue){
        this.error = error;
        this.returnValue = returnValue;
    }
}

//Converts a back end object to its front end representation
//@param dataMapping - the data mapping from DATA_MAPPINGS to use for the conversion
//@param backEndItem - the back end item to convert to a front end item
function convertToFrontEnd(dataMapping, backEndItem) { 
  const src =
    backEndItem?.Attributes ??
    backEndItem?.Item ??
    backEndItem?.data ??
    backEndItem?.result ??
    backEndItem; // fallback

  const newItem = {};
  for (const [frontKey, backKey] of Object.entries(dataMapping)) {
    newItem[frontKey] = src?.[backKey];
  }
  return newItem;
}

function convertToBackEnd(dataMapping, frontEndItem, defaultValues){
    let newItem = {};
    const mappingKeys = Object.keys(dataMapping);
    const mappingValues = Object.values(dataMapping);
    for(let i = 0; i < mappingValues.length; i++){
        newItem[mappingValues[i]] = frontEndItem[mappingKeys[i]];
    }
    // Apply provided defaults (only if not already set)
    if (defaultValues) {
      Object.keys(defaultValues).forEach(k => {
        if (newItem[k] === undefined) newItem[k] = defaultValues[k];
      });
    }
    return newItem;
}

export { APIResult, convertToFrontEnd, convertToBackEnd, getDefaultAPIHeaders, API_NAME };